import { AnalyticsSetupConnection } from "../models/AnalyticsOverview";
import { PlatformConnectionIcon } from "./PlatformConnectionIcon";

export function AnalyticsAccountIdentity({
  profileName,
  profileImage,
  platform,
  detail,
}: Pick<
  AnalyticsSetupConnection,
  "profileName" | "profileImage" | "platform"
> & { detail: string }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <PlatformConnectionIcon
        platform={platform}
        profileImage={profileImage}
        profileName={profileName}
        size="sm"
        disableTooltip
      />
      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-foreground">
          {profileName}
        </p>
        <p className="mt-0.5 text-xs text-muted-foreground">
          {formatPlatform(platform)} · {detail}
        </p>
      </div>
    </div>
  );
}

export function formatPlatform(platform: string): string {
  const labels: Record<string, string> = {
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    pinterest: "Pinterest",
    tiktok: "TikTok",
    youtube: "YouTube",
  };
  return (
    labels[platform] ?? platform.charAt(0).toUpperCase() + platform.slice(1)
  );
}
